import { SET_IOS_VERSIONS, SET_IOS_VERSION_PARAMS } from "../actions/ios";

const initialState = {
  iosVersions: {},
  iosVersionModalParams: { action: "create", iosVersion: {} },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IOS_VERSIONS:
      return {
        ...state,
        iosVersions: action.iosVersions,
      };
    case SET_IOS_VERSION_PARAMS:
      return {
        ...state,
        iosVersionModalParams: action.iosVersionModalParams,
      };
    default:
      return state;
  }
};
